// Define all constants
export const PendingDebitInvoicesLabel = 'Pending debit';
export const NotChasingInvoicesLabel = 'Not chasing';
export const NotChasingCustomersLabel = 'Not chasing';
export const ChasingInvoicesLabel = 'Chasing';
export const ChasingCustomersLabel = 'Chasing';
export const PaidInvoicesLabel = 'Paid';
export const MissingAddressLabel = 'Missing address';
export const MissingEmailLabel = 'Missing email address';
export const MissingNameLabel = 'Missing names';
export const MissingMobileLabel = 'Missing/invalid mobile';
export const ReadyForCollectionLabel = 'Collections ready';
export const PendingCollectionLabel = 'Pending';
export const WaitingContractLabel = 'Waiting contract';
export const CollectingLabel = 'Collecting';
export const CollectedLabel = 'Collected';
export const OverdueLabel = 'Overdue';
export const Overdue0to30Label = '0-30 days';
export const Overdue31to60Label = '31-60 days';
export const Overdue61to90Label = '61-90 days';
export const Overdue90plusLabel = '90+ days';
export const onPaymentPlanLabel = 'On payment plan';
export const latePaymentFeesLabel = 'With late payment fees';
export const noLatePaymentFeesLabel = 'Without late payment fees';
export const earlyPaymentDiscountsLabel = 'With early payment discounts';
export const noEarlyPaymentDiscountsLabel = 'Without early payment discounts';
export const inDispute = 'In dispute';
export const missingAddress = 'Missing address';
export const netBalanceAboveZeroLabel = 'Net balance > 0';
export const netBalanceIsZeroLabel = 'Net balance = 0';
export const netBalanceBelowZeroLabel = 'Net balance < 0';

// Also export as a default object for backward compatibility
const labels = {
  PendingDebitInvoicesLabel,
  NotChasingInvoicesLabel,
  NotChasingCustomersLabel,
  ChasingInvoicesLabel,
  ChasingCustomersLabel,
  PaidInvoicesLabel,
  MissingAddressLabel,
  MissingEmailLabel,
  MissingNameLabel,
  MissingMobileLabel,
  ReadyForCollectionLabel,
  PendingCollectionLabel,
  WaitingContractLabel,
  CollectingLabel,
  CollectedLabel,
  OverdueLabel,
  Overdue0to30Label,
  Overdue31to60Label,
  Overdue61to90Label,
  Overdue90plusLabel,
  onPaymentPlanLabel,
  latePaymentFeesLabel,
  noLatePaymentFeesLabel,
  earlyPaymentDiscountsLabel,
  noEarlyPaymentDiscountsLabel,
  inDispute,
  missingAddress,
  'Red AA': '#D75058',
  'Light Red 1': '#FFF2F3',
  'Light Red 2': '#F37E85',
  'Light Red 3': '#FEC3C6',
  netBalanceAboveZeroLabel,
  netBalanceIsZeroLabel,
  netBalanceBelowZeroLabel,
};

export default labels;
